import { render, staticRenderFns } from "./CurrentTodos.vue?vue&type=template&id=288971e9&"
import script from "./CurrentTodos.vue?vue&type=script&lang=js&"
export * from "./CurrentTodos.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTodos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports